const stats = [
  { value: "60+", label: "覆盖赛事", icon: "ri-trophy-line" },
  { value: "24/7", label: "实时直播", icon: "ri-live-line" },
  { value: "1080P", label: "高清画质", icon: "ri-hd-line" },
  { value: "3000+", label: "精彩回放", icon: "ri-film-line" },
];

export default function DataBand() {
  return (
    <section className="w-full bg-primary-950">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-10 md:py-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((s, i) => (
            <div
              key={s.label}
              className={`flex items-center gap-4 ${
                i !== 0 ? "lg:border-l lg:border-white/10 lg:pl-8" : ""
              }`}
            >
              <span className="w-12 h-12 rounded-lg bg-primary-500/20 text-accent-400 flex items-center justify-center shrink-0">
                <i className={`${s.icon} text-2xl`} />
              </span>
              <div>
                <p className="font-heading text-2xl md:text-3xl font-semibold text-white">
                  {s.value}
                </p>
                <p className="text-xs md:text-sm text-white/60 mt-0.5">{s.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}